import { FilterFragment as Filter, FilterInput, FilterType } from 'generated/graphql';

/**
 * Builds the display string for the current filter selection
 * Used by handleFilter in useReportsDashboardFilters
 */
export function getFilterDisplayString(
  filterInput: FilterInput[],
  productFilters: Filter[] | undefined,
  initialValue = '',
): string {
  if (!filterInput?.length) return initialValue;
  return filterInput.reduce((acc: string, curr: FilterInput) => {
    const filter = productFilters?.find((f) => f.type === curr.type);
    if (!filter) return acc;
    const selectedIDs = curr.selectedIDs.map((id) => Number(id));
    const appendType = curr.type !== FilterType.Class;
    const isDescription = curr.type === FilterType.Size;
    const typeLabel = filter.type.toLowerCase().slice(0, 3);
    const filterString = filter.options
      .filter(
        (option) =>
          selectedIDs.includes(Number(option.id)) &&
          (filter.type !== FilterType.Variety || (filter.type === FilterType.Variety && option.description !== '')),
      )
      .map((option) => {
        const label = isDescription
          ? option.description === 'No Size'
            ? option.description.replace(' ', '')
            : option.description
          : option.label;
        return appendType ? `${typeLabel}${label}` : label;
      });
    return `${acc.length > 0 ? acc + ' ' : acc}${filterString.toString()}`;
  }, initialValue);
}
